import Vue from 'vue';
import '@mdi/font/css/materialdesignicons.css';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'; // eslint-disable-line

import zhHant from 'vuetify/es5/locale/zh-Hant';
import en from 'vuetify/es5/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { zhHant, en },
    current: 'zhHant',
  },
  theme: {
    // dark: true,
    // disable: true,
    themes: {
      light: {
        black: '#000',
        primaryColor1: '#FB966E',
        primaryColor08: '#fb966e14', // #FFCDD2
        primaryColor16: '#fb966e29', // #3F51B5
        badgeColor: '#E06955',
        secondary: '#B3B3B3',
        $primaryGrayColor: '#00000073',
        $secondaryGray: '#e6e6e6',
        $thirdGray: '#F2F2F2',
        $quaternaryColor: '#1240AB',
        $quinaryColor: '#FF4040',
        $senaryColor: '#00BB3F',
        $quaternaryGray: '#cccccc',
        $floorIconPrimaryColor: '#808080',
        $floorIconSecondColor: '#DC815D',
        $floorIconThirdColor: '#83756F',
      },
      red: {
        black: '#000',
        primaryColor1: '#FB966E',
        primaryColor08: '#fb966e14', // #FFCDD2
        primaryColor16: '#fb966e29', // #3F51B5
        badgeColor: '#E06955',
        $primaryGrayColor: '#00000073',
        $secondaryGray: '#e6e6e6',
        $thirdGray: '#F2F2F2',
        $quaternaryColor: '#1240AB',
        $quinaryColor: '#FF4040',
        $senaryColor: '#00BB3F',
        $quaternaryGray: '#cccccc',
        $floorIconPrimaryColor: '#808080',
        $floorIconSecondColor: '#DC815D',
        $floorIconThirdColor: '#83756F',
      },
      // dark: {
      //   black: 'red',
      //   primaryColor1: 'red',
      //   primaryColor08: 'red',
      //   primaryColor16: 'red',
      //   badgeColor: 'red',
      //   $primaryGrayColor: 'red',
      //   $secondaryGray: 'red',
      //   $thirdGray: 'red',
      //   $quaternaryColor: 'red',
      //   $quinaryColor: 'red',
      //   $senaryColor: 'red',
      //   $quaternaryGray: 'red',
      //   $floorIconPrimaryColor: 'red',
      //   $floorIconSecondColor: 'red',
      //   $floorIconThirdColor: 'red',
      // },
    },
  },
  breakpoint: {
    thresholds: {
      xs: 375,
      sm: 476,
      md: 768,
      lg: 1000,
      xl: 1440,
    },
    scrollBarWidth: 0,
    mobileBreakpoint: 1440,
  },
});
